import { render } from "./RightNav.vue?vue&type=template&id=647be867&scoped=true"
import script from "./RightNav.vue?vue&type=script&lang=js"
export * from "./RightNav.vue?vue&type=script&lang=js"

import "./RightNav.vue?vue&type=style&index=0&id=647be867&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647be867"]])

export default __exports__